<template>
    <b-container fluid>
        <app-supervision-activity-header
            >Lista de Chequeo</app-supervision-activity-header
        >
        <b-row class="my-2">
            <b-col cols="12" md="3" offset-md="3">
                <app-form-select
                    label="Sede"
                    :options="venues"
                    v-model="venueId"
                    :disabled="!venues.length"
                    value-field="id"
                    text-field="name"
                    @change="loadServiceSpots"
                ></app-form-select>
            </b-col>

            <b-col cols="12" md="3">
                <app-form-select
                    label="Puesto"
                    :options="serviceSpots"
                    v-model="serviceSpotId"
                    :disabled="!serviceSpots.length"
                    value-field="id"
                    text-field="name"
                ></app-form-select>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col>
                <b-row
                    v-for="(cat, i) in categories"
                    :key="cat.id"
                    class="align-items-center flex-column"
                >
                    <b-col cols="12" md="6" class="font-weight-bold mb-3">
                        <b-alert variant="info" show>
                            {{ i + 1 }} - {{ cat.name }}
                        </b-alert>
                    </b-col>
                    <b-col
                        cols="12"
                        md="6"
                        v-for="(item, j) in getItems(cat.id)"
                        :key="item.id"
                        class="mb-2"
                    >
                        <app-item
                            :item="item"
                            :catIndex="parseInt(i) + 1"
                            :itemIndex="parseInt(j) + 1"
                            @change="onAnswer"
                        ></app-item>
                    </b-col>
                    <b-col cols="12">
                        <hr />
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row class="justify-content-end">
            <b-col cols="12" md="3" lg="2">
                <b-btn
                    variant="confirm"
                    block
                    @click="sendAnswers"
                    :disabled="inProgress"
                    >Enviar Respuestas</b-btn
                >
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import supervisionRepository from '@repositories/supervision.repository'
import { mapGetters } from 'vuex'
import SupervisionChecklistItem from './SupervisionChecklistItem.vue'
import SupervisionActivityHeader from '../SupervisionActivityHeader'
import { getCurrentPosition } from '../../../utils/localization'
import clientsRepository from '@repositories/clients.repository'
export default {
    components: {
        appItem: SupervisionChecklistItem,
        appSupervisionActivityHeader: SupervisionActivityHeader,
    },
    data: () => ({
        answers: [],
        items: [],
        serviceSpotId: '',
        serviceSpots: [],
        venueId: '',
        venues: [],
    }),
    computed: {
        ...mapGetters(['supervisionClient']),
        categories() {
            const categories = {}
            this.items.map((item) => {
                categories[item.supervision_checklist_category.id] =
                    item.supervision_checklist_category
            })
            return Object.values(categories)
        },
    },
    methods: {
        async loadChecklist() {
            const sr = { ...supervisionRepository }
            try {
                this.items = await sr.loadChecklist()
            } catch (err) {
                this.handleErrors(err)
            }
        },
        getItems(catId) {
            const items = this.items.filter(
                (item) => item.supervision_checklist_category.id === catId
            )
            return items
        },
        onAnswer(resp) {
            const results = this.answers.filter(
                (item) => item.checklistId !== resp.checklistId
            )
            results.push(resp)
            this.answers = results
        },
        validateAnswers() {
            if (!this.venueId) {
                toastr.error(
                    'Debe seleccionar la sede donde esta diligenciando la lista de chequeo'
                )
                return false
            }

            if (this.items.length !== this.answers.length) {
                toastr.error('Debe diligenciar todas las respuestas')
                return false
            }

            const incompletes = this.answers.filter(
                (item) => item.valid === 0 && item.notes.length < 10
            )
            if (incompletes.length > 0) {
                toastr.error('Debe completar algunas respuestas')
                return false
            }

            return true
        },
        async loadVenues() {
            const cr = { ...clientsRepository }
            try {
                this.venues = await cr.getVenuesByClient(
                    this.supervisionClient.id
                )
            } catch (err) {
                this.handleErrors(err)
            }
        },
        async sendAnswers() {
            if (!this.validateAnswers()) return false

            const { latitude, longitude } = await getCurrentPosition()

            const payload = {
                userId: this.user.id,
                clientId: this.supervisionClient.id,
                answers: this.answers,
                venueId: this.venueId,
                serviceSpotId: this.serviceSpotId,
                latitude,
                longitude,
            }

            const sr = { ...supervisionRepository }

            try {
                const data = await sr.saveChecklistAnswers(payload)
                this.answers = []
                toastr.success('Lista de chequeo registrada satisfactoriamente')
                this.$router.push({ name: 'supervisionIndexPage' })
            } catch (err) {
                this.handleErrors(err)
            } finally {
            }
        },
        async loadServiceSpots() {
            const cr = { ...clientsRepository }
            try {
                const { data } = await cr.getServiceSpotsByVenue(this.venueId)
                this.serviceSpots = data
                if (data.length === 1) {
                    this.serviceSpotId = data[0].id
                }
            } catch (err) {
                this.handleErrors(err)
            }
        },
    },
    created() {
        this.loadChecklist()
        this.loadVenues()
    },
}
</script>
